define('SageDotCom/Components/Content/ProductTour/ProductTourHeroVideo',["jquery"],
    function ($) {

        function ProductTourHeroVideo(scope) {
            function init() {
                var introShouldPause = false;
                var introCanPause = true;
                var videos = $(scope).find("[data-trigger='pt-intro-trigger']");

                if (videos.length > 0) {
                    var introVideo = videos.get(0);
                    var secondVideo = videos.get(1);

                    var playVideo = function(video) {
                        var promise = video.play();

                        if (promise !== null && promise !== undefined) {
                            promise.then(function() {
                                    video.muted = false;
                                },
                                function(reason) {
                                    introShouldPause = true;
                                    video.muted = true;
                                    video.play();
                                });
                        }
                    };

                    var timeUpdateFunction = function() {
                        if (introCanPause && introShouldPause && this.currentTime > 4) {
                            this.pause();
                            introShouldPause = false;
                        };
                    };

                    var canPlayFunction = function() {
                        playVideo(introVideo);
                    };

                    if (secondVideo) {
                        var initialVideoFinishedFunction = function() {
                            //even though video ends, because the remaining time is less than a second, ended is false, duration does not equal currenttime etc
                            if (introVideo.duration - introVideo.currentTime < 1) {
                                //if the second video is a video, replace the elements
                                //if the second video is a link, get the href, switch the src, remove event listeners
                                if ($(secondVideo).is("video")) {
                                    $(introVideo).hide();
                                    $(secondVideo).show();

                                } else {
                                    var href = secondVideo.href;
                                    if (href) {
                                        introVideo.removeEventListener("canplay", canPlayFunction);
                                        introVideo.removeEventListener("timeupdate", timeUpdateFunction);
                                        introVideo.removeEventListener("pause", initialVideoFinishedFunction);
                                        $(introVideo).attr("src", href);
                                    }
                                }
                            }
                        }
                    }

                    introVideo.addEventListener("pause", initialVideoFinishedFunction);
                    introVideo.addEventListener("timeupdate", timeUpdateFunction);
                    introVideo.addEventListener("canplay", canPlayFunction);

                    //Video might be ready to play before the event listener was attached
                    var HAVE_ENOUGH_DATA = 4;
                    if (introVideo.readyState === HAVE_ENOUGH_DATA) {
                        canPlayFunction();
                    }
                }
            }

            init();
        };

        return function initProductTourHeroVideo(args) {
            return args.IsExperienceEditorEditing === false ?
                new ProductTourHeroVideo(args.scope) : null;
        };
    });
